import { isMobile } from '@theme/use-device-detection'

function initSmoothScroll() {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return
  if (isMobile()) return
  if (!(window.gsap && window.Lenis)) return

  const lenis = new window.Lenis({
    autoRaf: false,
    lerp: 0.165,
    wheelMultiplier: 1.25
  })
  window.lenis = lenis

  window.gsap.ticker.add((time) => lenis.raf(time * 1000))
  window.gsap.ticker.lagSmoothing(500, 33)
  lenis.on('scroll', () => window.ScrollTrigger?.update())
}

initSmoothScroll()
